import { makeStyles } from '@alpha/ui-lib/theme';

export const useStyles = makeStyles(
  () => ({
    buttons: {
      display: 'flex',
      justifyContent: 'space-between',
      paddingTop: 16,
    },
    icon: {
      marginRight: 13,
    },
    wrapper: {
      display: 'flex',
      justifyContent: 'center',
    },
  }),
  { name: 'ActionDropDown' },
);

export default useStyles;
